export default {
  validate: {
    required: '{field} is required',
    invalid: 'Invalid {field}',
    maxLength: 'Maximum {length} characters',
    minLength: 'Minimum of {length} characters are required',
    sameAs: '{field} does not match',
    email: 'Please input valid email',
    maxValue: '{field} should not larger than {value}',
    minValue: '{field} should not less than {value}',
    accept_term: 'Please read and agree with the terms & conditions.',
    dateFormat: 'Date is not in correct format'
  },
  common: {
    home: 'Home',
    countrySelector: {
      newOptionHint: 'press enter for custom option',
      selectAll: 'Select All',
      selection: {
        nItemSelected: '+{n} others',
        all: 'All {labelPlural}'
      }
    },
    multipleSelector: {
      selectAll: 'Select All',
      selection: {
        nItemSelected: '+{n} others',
        all: 'All {labelPlural}'
      }
    },
    dateRangePicker: {
      presetsHeading: 'Presets',
      selected: 'Selected',
      range: '{start} to {end}',
      selectRange: 'Select range',
      presets: {
        halfYear1: 'H1 {year}',
        halfYear2: 'H2 {year}',
        fullYear: 'FY {year}',
        custom: 'Custom'
      }
    }
  },
  APP_NAME: 'RBA Essential',
  'User Guide': 'User Guide',
  Organization: 'Organization',
  Services: 'Services',
  Username: 'Username',
  Password: 'Password',
  Email: 'Email',
  login: {
    welcome: 'Welcome to RBA Essential',
    subtitle: 'Sign in to your account',
    error: {
      failed: 'Login Failed, Please check your information.',
      tooMany: 'Too many failed authentication attempts in a period of time, please try again later.'
    },
    buttons: {
      sign_in: 'Sign In',
      forgot_pw: 'Forgot Password'
    },
    tnc: {
      statementPrefix: 'I agree with the ',
      hyperText: '&nbsp;Terms & Conditions',
      title: 'Terms & Conditions',
      content: '<p>&nbsp;</p><p><strong><u>S</u></strong><strong><u>cope of Use</u></strong></p> <p>The Subscriber undertakes that it shall, and shall procure that each User shall at all times:</p> <ul> <li>not use the Data in any way which might infringe any license granted to TESS, any law (including criminal and/or data protection law) and /or use any Data for any unlawful and/or unauthorized purpose;</li> <li>only allow User to make use of and have access to the Database;</li> <li>not remove any copyright or other notice contained or included in any Data;</li> <li>acknowledge that the Data is licensed, not sold, and that it obtains no ownership of the Data;</li> <li>not use the Database, and/or any Data to compete in any way with TESS and/or any licensor of TESS;</li> <li>not in any circumstances, use, nor allow any third party to use, any automated software, process, programme, robot, web crawler, spider, data mining, trawling, screen scraping or other similar software (regardless of whether or not the resulting information would then be used for its internal purposes);</li> <li>not transfer any Data or provide access to any Data to any third party without first obtaining the prior written consent of TESS; and</li> <li>promptly upon becoming aware of any breach of this clause notify TESS thereof, and promptly provide such details as TESS reasonably request.</li> </ul> <p>The Subscriber acknowledges and accepts as reasonable that the undertakings given at above clause are of material importance to TESS and that TESS has entered into this Agreement in reliance on these undertakings.&nbsp; The Subscriber acknowledges that without affecting any rights or remedies that TESS may have, damages would not be an adequate remedy for any breach of subscriber of the clause above and that TESS shall be entitled to apply for the remedies of injunction, specific performance and other equitable relief for any threatened or actual breach of the clause above, and that no proof of special damages shall be necessary for the enforcement of this clause.</p> <p>Subscriber shall ensure that each User Agreement contains the following provisions:</p> <p>&nbsp;</p> <ol> <li>The User acknowledges that: <ul> <li>the Database and the Data are licensed to the User, not sold; and</li> <li>it obtains no ownership of the Database and the Date;</li> </ul> </li> <li>User acknowledges that the User shall have no right (and shall not permit any third party) to adapt, reverse engineer, decompile, disassemble, modify or make error corrections to the Database and the Data; and</li> <li>TESS&rsquo;s liability to any User will be limited in accordance with the clauses below.</li> </ol> <p>&nbsp;</p> <p><strong><u>Liability</u></strong></p> <p>Notwithstanding any other provision of this Agreement, neither party excludes or limits liability to the extent that the same may not be excluded or limited under governing law.</p> <p>&nbsp;</p> <p>The Subscriber acknowledges that TESS complies data but does not originate it.&nbsp; Accordingly, the Database, any service and/or Data are provided on an as is and as available basis and TESS does not make any representations or warranties of any kind and whether statutory, express or implied relating to the Data (including relating to the timeliness, currency, continuity, accuracy, completeness, merchantability, non-infringement or fitness for a particular purpose thereof).&nbsp; In particular, the Subscriber acknowledges that Data may be obtained from sources including the darkweb, and accordingly no representation and/or warranty is given that the provision of the Data by TESS complies with any law.</p> <p>&nbsp;</p> <p>The Subscriber acknowledges that every business decision involves the assumption of a risk and that TESS, in furnishing the Data to the Subscriber, does not and will not underwrite that risk, in any manner whatsoever. Neither TESS, nor any Data supplier, shall be liable to either the Subscriber or any third party for any loss caused in whole or in part by TESS&rsquo; procuring, compiling, collecting, interpreting, reporting, communicating, supplying or delivering the Data and the Subscriber agrees not to bring any claim against TESS and/or its Data suppliers in respect thereof.</p> <p>&nbsp;</p> <p>The Subscriber acknowledges that:</p> <ul> <li>use of Database by it and/or any permitted user is at Subscriber&rsquo;s sole risk;</li> <li>whilst TESS obtains the Data in good faith from sources which TESS considers to be reliable, the contents of the Database are based on Data supplied to TESS by third parties and are not independently verified by TESS;</li> <li>TESS does not guarantee the sequence, accuracy, completeness and/or timeliness of the Database;</li> <li>the service is not intended to and does not provide tax, legal or investment advice;</li> <li>the Subscriber should seek independent tax, legal and/or investment advice before acting on Data obtained from the Database, and</li> <li>TESS shall not be under, and excludes to the fullest extent permitted by law all liability to the Subscriber for, any liability whatsoever in respect of:</li> <li>any mistakes, errors, inaccuracies or omissions in, or in completeness of, the Database;</li> <li>delays in updating the Database or non-availability thereof;</li> <li>loss of profit, business revenue, goodwill and anticipated savings (whether direct or indirect) incurred through the use of the Database;</li> <li>trading, investment or other losses which Subscriber may incur as a result of use of or reliance upon the Database and/or Data and/or;</li> <li>internet failure, and/or failure of the Subscriber to have in place any necessary software or equipment; and/or</li> <li>any claim that the provision of the Data infringes any law.</li> <li>Each party excludes liability for any indirect, special, incidental and/or consequential loss and/or damages incurred by the other party in connection with this Agreement.</li> </ul>'
    }
  },
  home: {
    nav: {
      login: 'Login'
    },
    hero: {
      title: 'RBA Essential',
      subtitle: 'One-stop aml solution that fulfills your requirement on the latest anti-money laundering regulations ,together with an easy-to-use experience in streamlined customer onboarding and ongoing screening functionality.',
      contactButton: 'Contact Us',
      loginButton: 'Login'
    },
    features: {
      title: 'We\'ve streamlined your Due Diligence Experience',
      cloudCrm: {
        title: 'Cloud CRM',
        description: 'Cloud Customer Relationship Management (CRM) allows you to store all client information and due diligence records in cloud to prevent physical loss and damage'
      },
      nameScreening: {
        title: 'Name Screening',
        description: 'AI Powered Enhanced Watchlist Engine (EWE) allows you to use the least effort to attain the greatest efficiency by reducing false positives and integrating robust technology'
      },
      complianceReports: {
        title: 'Compliable Report',
        description: 'RBA Essential allows you reduce penalty risks by generating monthly due diligence report and individual reports that fully comply with regulators\' expectations'
      }
    },
    statistics: {
      countries: {
        number: '200+',
        label: 'Countries',
        description: 'Watchlist includes entities from over 200 countries that covers PEPs, Adverse Media, Regulatory and Sanction Lists'
      },
      entities: {
        number: '5M+',
        label: 'Watchlist Entities',
        description: 'Watchlist contains more than 5 million individuals and corporates ranging from sanctions, PEPs and Adverse Media'
      },
      compliance: {
        number: '100%',
        label: 'Compliance',
        description: 'RBA Essential allows you to fully comply with the latest regulation by meeting the regulators\' expectations'
      }
    },
    solution: {
      title: 'One-stop Cloud Solution to Comply with the Latest AML Regulations',
      description: 'To make your compliance program more efficient',
      steps: {
        screening: 'Onboarding Due Diligence',
        nameCheck: 'Name Screening',
        riskAnalysis: 'Risk Profiling',
        reporting: 'Reporting',
        recordKeeping: 'Record-keeping'
      },
      stepDescriptions: {
        screening: 'Accurately assess customer names and their money laundering risk factors for timely due diligence',
        nameCheck: 'Comprehensive name screening through advanced AI technology to ensure compliance requirements',
        riskAnalysis: 'In-depth analysis of customer risk levels to provide accurate risk assessment reports',
        reporting: 'Generate detailed compliance reports and analysis documents that meet regulatory requirements',
        recordKeeping: 'Securely store and manage all customer data and review records to ensure data integrity'
      }
    },
    testimonial: {
      title: 'To make your compliance program more efficient',
      quote: 'With the latest cutting-edge technology, we strive to deliver a full function AML solution within a reasonable cost that helps you to meet full compliance standard.',
      author: {
        name: 'Simon Leung',
        title: 'AML Advisor, TESS ASIA'
      }
    },
    contact: {
      title: 'Contact Us',
      expert: {
        title: 'AML Solution Expert Consultant',
        phone: '(852) 9881 0640'
      },
      form: {
        name: 'Name',
        email: 'Email',
        message: 'How can we help you?',
        submit: 'Submit',
        agreement: 'By submitting this information, you agree to be contacted by us',
        success: {
          title: 'Submission Successful',
          message: 'We have received your inquiry and will contact you as soon as possible'
        },
        error: {
          title: 'Submission Failed',
          message: 'An error occurred during submission, please try again later'
        }
      }
    }
  },
  forgot_pw: {
    title: 'Forgot Password',
    subtitle: 'Please provide the following necessary information to reset your password',
    msg: {
      success: 'Reset email sent. Please check your email.',
      error: 'Something went wrong, please contact TESS ASIA.',
      incorrect_info: 'Information does not match.'
    },
    buttons: {
      back_login: 'Go Back to Login',
      reset: 'Reset',
      email_sent: 'Email Sent'
    }
  },
  reset_pw: {
    title: 'Reset Password',
    subtitle: {
      default: 'Please enter new password',
      success: 'Password was successfully reset.'
    },
    form: {
      new_pw: 'New Password',
      confirm_pw: 'Confirm Password'
    },
    msg: {
      error: 'Something went wrong, please contact TESS ASIA.',
      expired: 'Reset Password Token Expired.',
      incorrect_info: 'Link Expired. Please make another password reset request.'
    },
    strength: {
      label: 'Strength',
      level: {
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong'
      },
      weakNotAllowed: 'Weak password is not allowed.'
    },
    diversity: {
      atLeastOneUpperCase: 'At least one upper case letter',
      atLeastOneLowerCase: 'At least one lower case letter',
      atLeastOneNumber: 'At least one number',
      atLeastOneSpecialCharacter: 'At least one special character',
      longEnough: 'Long enough',
      notOnWeakList: 'Not exist on the weak cipher list'
    },
    buttons: {
      confirm: 'Confirm',
      back_login: 'Go Back to Login',
      login: 'Login'
    }
  },
  token: {
    refreshing: 'Renewing authentication...',
    refreshed: 'Authentication has been renewed',
    refreshFailed: 'Authentication renew failed. You are forcibly logged out.'
  },
  dashboard: {
    cards: {
      pending: {
        subtitle: 'Pending Alerts',
        buttons: {
          view: 'View Alerts'
        }
      },
      screening: {
        subtitle: 'Single Screening'
      },
      company: {
        subtitle: 'Active Company',
        buttons: {
          view: 'View All'
        }
      },
      person: {
        subtitle: 'Active Natural Person',
        buttons: {
          view: 'View All'
        }
      }
    },
    charts: {
      line: {
        title: 'Alerts Line Chart',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        labels: {
          alert: 'Alerts'
        }
      },
      donut: {
        title: 'Alert Status Chart',
        labels: {
          true_hit: 'True Hit',
          false_hit: 'False Hit',
          pending: 'Pending'
        }
      }
    }
  },
  company: {
    // details: {
    //     form: {
    //         coi_number: 'COI Number',
    //         batch_scan_date: ''
    //     }
    // },
    listing: {
      title: 'Company',
      buttons: {
        add: 'Add'
      },
      table: {
        // coi_number: {
        //     label: 'COI Number',
        // },
        // status: {
        //     label: 'Status',
        //     options: {
        //         active: 'Active',
        //         inactive: 'Inactive'
        //     }
        // },
        ref_id: {
          label: 'Ref ID'
        },
        names: {
          label: 'Company Name'
        },
        batch_scan_date: {
          label: 'Batch Screened'
        },
        create_date: {
          label: 'Date Created'
        },
        updated_date: {
          label: 'Date Updated'
        }
        // action: {
        //     label: 'Action'
        // }
      }
    },
    details: {
      title: 'Company Info',
      buttons: {
        print: 'Print',
        save: 'Save',
        delete: 'Delete'
      },
      form: {
        status: {
          label: 'Status',
          options: {
            active: 'Active',
            inactive: 'Inactive'
          }
        },
        risk_level: {
          label: 'Geographical Risk Level',
          options: {
            'High Risk': 'High Risk',
            'Medium Risk': 'Medium Risk',
            'Low Risk': 'Low Risk',
            'Not In List': 'Not In List'
          },
          loading: 'calculating...'
        },
        ref_id: {
          label: 'Reference ID'
        },
        company_type: {
          label: 'Type of Company',
          options: {
            1: 'Public Limited',
            2: 'Private Limited',
            3: 'Private Unlimited with Share Capital',
            4: 'Public Unlimited with Share Capital',
            5: 'Company Limited by Guarantee without a Share Capital',
            6: 'Registered Non-Hong Kong Company',
            7: 'Unlimited Partnership',
            8: 'Unlimited Sole Proprietorship'
          }
        },
        pps_members: {
          label: 'PPS Members'
        },
        coi_number: {
          label: 'Company Number (COI No.)'
        },
        br_number: {
          label: 'BR Number'
        },
        incorp_place: {
          label: 'Place of Incorporation',
          hint: 'this value will cause a change in the geographical risk level'
        },
        incorp_date: {
          label: 'Date of Incorporation'
        },
        tel: {
          label: 'Contact'
        },
        fund_source: {
          label: 'Fund Source'
        },
        business_nature: {
          label: 'Business Nature'
        },
        contact_person: {
          label: 'Name'
        },
        contact_person_tel: {
          label: 'Tel'
        },
        contact_fax: {
          label: 'Fax'
        },
        is_br_3y: {
          label: '3 Years BRC'
        },
        estab_date: {
          label: 'Establishment Date of business'
        },
        ma_name: {
          label: 'Name of the Charter, Statutes, Memorandum'
        },
        coi_name: {
          label: 'Name of the Certificate of Incorporation'
        },
        acc_start_date: {
          label: 'Accounting Start Date'
        },
        acc_end_date: {
          label: 'Accounting End Date'
        },
        acc_no_reason: {
          label: 'Statement of no accounts',
          placeholder: 'Select a reason of no accounting period',
          options: [
            'Not required by the law',
            'The company has been incorporated for less than 18 months'
          ]
        }
      },
      form_name: {
        title: 'Names',
        validate: {
          at_least_one_company_name: 'Need at least one company name',
          duplicate_local: '{field} is duplicated',
          duplicate_db: '{field} is duplicated in database',
          chinese_words: '{field} must contain Chinese words'
        },
        english: {
          label: 'English Name'
        },
        chinese: {
          label: 'Chinese Name'
        },
        buttons: {
          edit: 'Editing "{value}"',
          select: 'Select to Edit',
          update: 'Update',
          add: 'Add',
          remove: 'Remove'
        },
        dropdown: {
          title: 'We find some similar records. You may switch to existing clients by clicking it.',
          no_records: 'No Similar Records'
        }
      },
      form_email: {
        title: 'Emails',
        email: {
          label: 'Email'
        },
        effect_date: {
          label: 'Effective Date'
        },
        dropdown: {
          title: 'We find some similar records. You may switch to existing clients by clicking it.',
          no_records: 'No Similar Records'
          // items: {
          //     company_type: 'Type',
          //     coi_number: ''
          // }
        },
        buttons: {
          edit: 'Editing "{value}"',
          select: 'Select to Edit',
          update: 'Update',
          add: 'Add',
          remove: 'Remove'
        }
      },
      form_address: {
        titles: {
          current: 'Proposed / Current Address of Registered Office',
          correspondence: 'Correspondence Address',
          principal_hk: 'Principal Place of Business',
          principal_registered_country: 'Principal Place of Business in Registered Country'
        },
        address_1: {
          label: 'Address Line1'
        },
        address_2: {
          label: 'Address Line2'
        },
        address_3: {
          label: 'Address Line3'
        },
        address_4: {
          label: 'Address Line4 (Country)'
        },
        effect_date: {
          label: 'Effective Date'
        },
        dropdown: {
          title: 'We find some similar records. You may switch to existing clients by clicking it.',
          no_records: 'No Similar Records'
        },
        buttons: {
          edit: 'Editing "{value}"',
          select: 'Select to Edit',
          update: 'Update',
          add: 'Add',
          remove: 'Remove'
        }
      },
      form_member: {
        title: 'Members',
        buttons: {
          add: 'Add Member/Officer'
        },
        roles: {
          founder: 'Founder',
          director: 'Director',
          secretary: 'Secretary',
          auth_rep: 'Auth Rep',
          significant_controller: 'Significant Controller'
        },
        table: {
          role: {
            label: 'Role'
          },
          name: {
            label: 'Name'
          },
          alerts: {
            label: 'Alerts (Pending / True Hit / False Hit)'
          },
          action: {
            label: 'Action'
          }
        }
      },
      form_accounting: {
        title: 'Accounts',
        accounting_needed: {
          label: 'Accounting Period',
          options: {
            yes: 'Yes',
            no: 'No'
          },
          peroid: {
            from: 'Yes, from',
            to: 'to'
          }
        }
      },
      form_oversea: {
        title: 'Overseas Company Registration Information'
      },
      form_bankinfo: {
        buttons: {
          add: 'Add Bank Information',
          remove: 'Remove'
        },
        acc_number: {
          label: 'Account No'
        },
        acc_bank: {
          label: 'Bank'
        },
        acc_type: {
          label: 'Account Type'
        },
        acc_currency: {
          label: 'Currency'
        },
        acc_open_date: {
          label: 'Open Date'
        },
        acc_close_date: {
          label: 'Close Date'
        },
        acc_remarks: {
          label: 'Remarks'
        }
      },
      tabs: {
        info: 'Company Information',
        address: 'Addresses',
        members: 'Members',
        contact: 'Contact Person',
        business: 'Business Registration',
        others: 'Others',
        roles: 'Roles Info',
        alerts: 'Alerts',
        alertcasepool: 'Alert Case Pool',
        bank: 'Bank Info',
        attachment: 'Attachments',
        transaction: 'Transactions',
        riskAssessment: 'Risk Assessment'
      },
      msg: {
        update_member: {
          title: 'Update Member',
          success: 'Successfully Updated'
        },
        add_member: {
          title: 'Add Member',
          success: 'Successfully Added'
        },
        valid: {
          title: 'Validate Company Detail',
          success: 'Company detail is valid',
          error: 'Company detail is invalid'
        },
        save: {
          title: 'Save Company',
          success: 'Successfully Saved',
          error: 'Save Failed',
          exception: 'Save Failed (Exception)',
          error_unique: 'Duplicate Reference ID is not allowed.'
        },
        load: {
          title: 'Load Company Detail',
          success: 'Successfully Loaded',
          error: 'Load Detail Failed'
        }
      }
    }
  },
  alert: {
    listing: {
      title: 'Alerts'
    },
    details: {
      title: 'Alert Status',
      buttons: {
        unlock: 'Modify',
        save: 'Save',
        view_details: 'View Screening Details',
        suggestions: 'Suggestions',
        more_audit: 'More',
        close: 'Close',
        download: 'Download'
      },
      form: {
        id: {
          label: 'Alert ID'
        },
        service_id: {
          label: 'Screening ID'
        },
        hit_name: {
          label: 'Name'
        },
        hit_status: {
          label: 'Hit Status',
          options: [
            'Pending',
            'True hit',
            'False hit'
          ]
        },
        hit_identity: {
          label: 'Identity No.'
        },
        hit_nationality: {
          label: 'Nationality'
        },
        create_date: {
          label: 'Hit Date'
        },
        updated_date: {
          label: 'Updated At'
        },
        exposition: {
          label: 'Exposition',
          options_true: [
            'Relating to negative news on non-AML/CFT matter.  Conviction record, if any, to be included in application form.',
            'Relating to Bankruptcy Record.  Information to be included in application from.',
            'Relating to domestic PEP.  No action is required.',
            'Relating to negative news on AML/CFT matter.  Enhanced CDD is required. Conviction record, if any, to be included in application form.',
            'Relating to foreign / significant PEP.  Enhanced CDD is required.',
            'Relating to sanctioned subject / known terrorist.  Report to authority is required.',
            'Others'
          ],
          options_false: [
            'Known information of customer (a natural person), such as gender, nationality, identification number, date of birth, and etc, is different with the targeted persons',
            'Known information of customer (an entity), such as place of operation / registration, incorporation number, and etc, is different with the targeted entity',
            'Others'
          ]
        },
        remarks: {
          label: 'Remarks',
          options: [
            'Enhanced CDD has been completed with AML/CFT risks assessed to be acceptable.  Allows to be on board with high risk rating and recording the fact in application form if required.',
            'Enhanced CDD has been completed with AML/CFT risks assessed to be UNACCEPTABLE.  No service would be provided.',
            'Suspicious transaction report has been prepared and filed to the authority.'
          ]
        }
      },
      audit: {
        title: 'Audit Trail',
        previous: 'Previous',
        new: 'New',
        no_records: 'No audit data is available'
      },
      msg: {
        valid: {
          title: 'Validate Alert Detail',
          invalid: 'Alert detail is invalid'
        },
        save: {
          title: 'Save Alert',
          success: 'Successfully Saved',
          error: 'Save Failed'
        }
      }
    },
    bulk_action: {
      header: 'Bulk Update Alert Cases',
      msg: {
        process: 'Processing cases...',
        success: 'Successfully Updated'
      }
    }
  },
  person: {
    listing: {
      title: 'Natural Person',
      buttons: {
        add: 'Add'
      },
      table: {
        // coi_number: {
        //     label: 'COI Number',
        // },
        // status: {
        //     label: 'Status',
        //     options: {
        //         active: 'Active',
        //         inactive: 'Inactive'
        //     }
        // },
        ref_id: {
          label: 'Ref ID'
        },
        idens: {
          label: 'Identity No.'
        },
        names: {
          label: 'Name'
        },
        batch_scan_date: {
          label: 'Batch Screened'
        },
        create_date: {
          label: 'Date Created'
        },
        updated_date: {
          label: 'Date Updated'
        }
        // action: {
        //     label: 'Action'
        // }
      }
    },
    details: {
      title: 'Natural Person Info',
      buttons: {
        save: 'Save',
        delete: 'Delete'
      },
      form: {
        status: {
          label: 'Status',
          options: {
            inactive: 'Inactive',
            active: 'Active'
          }
        },
        risk_level: {
          label: 'Geographical Risk Level',
          options: {
            'High Risk': 'High Risk',
            'Medium Risk': 'Medium Risk',
            'Low Risk': 'Low Risk',
            'Not In List': 'Not In List'
          },
          loading: 'calculating...'
        },
        ref_id: {
          label: 'Reference ID'
        },
        tel: {
          label: 'Tel'
        },
        fax: {
          label: 'Fax'
        },
        dob: {
          label: 'Date of Birth'
        },
        pob: {
          label: 'Nationality',
          hint: 'this value will cause a change in the geographical risk level'
        },
        gender: {
          label: 'Gender',
          options: {
            empty: '- Select -',
            male: 'Male',
            female: 'Female',
            others: 'Others'
          }
        }
      },
      form_name: {
        titles: {
          english: 'English',
          chinese: 'Chinese',
          english_alias: 'English Alias',
          chinese_alias: 'Chinese Alias'
        },
        buttons: {
          edit: 'Editing "{value}"',
          select: 'Select to Edit',
          update: 'Update',
          add: 'Add',
          remove: 'Remove'
        },
        validate: {
          at_least_one_name: 'Need at least one name',
          duplicate_local: 'Name is duplicated',
          duplicate_db: 'Name is duplicated in system',
          chinese_words: 'Chinese Name must contain Chinese words'
        },
        lang: {
          label: 'Language',
          options: {
            english: 'English',
            chinese: 'Chinese'
          }
        },
        name_type: {
          label: 'Type',
          options: {
            primary: 'Primary',
            alias: 'Alias'
          }
        },
        sur: {
          label: 'Surname'
        },
        other: {
          label: 'Other Names'
        },
        effect_date: {
          label: 'Effective Date'
        },
        dropdown: {
          title: 'We find some similar records. You may switch to existing clients by clicking it.',
          no_records: 'No Similar Records'
        }
      },
      form_iden: {
        title: 'Identity Document',
        buttons: {
          edit: 'Editing "{value}"',
          select: 'Select to Edit',
          update: 'Update',
          add: 'Add',
          remove: 'Remove'
        },
        validate: {
          hkid_valid_format: 'Please input valid HKID format (e.g A123456(7))',
          hkid_checksum: 'Please input valid HKID checkdigit',
          duplicate_db: 'Identity document is duplicated in system',
          duplicate_local: 'Identity document is duplicated'
        },
        type: {
          label: 'Type',
          options: [
            'Others',
            'HKID',
            'Passport'
          ]
        },
        id_number: {
          label: 'Identity No.'
        },
        id_number_security_num: {
          label: 'Security No.'
        },
        expiry_date: {
          label: 'Expiry Date'
        },
        expiry_date_security_num: {
          label: 'Security No.'
        },
        country: {
          label: 'Country'
        },
        effect_date: {
          label: 'Effective Date'
        },
        dropdown: {
          title: 'We find some similar records. You may switch to existing clients by clicking it.',
          no_records: 'No Similar Records'
        }
      },
      form_address: {
        title: 'Addresses',
        buttons: {
          edit: 'Editing "{value}"',
          select: 'Select to Edit',
          update: 'Update',
          add: 'Add',
          remove: 'Remove',
          close: 'Close'
        },
        address_1: {
          label: 'Address Line1'
        },
        address_2: {
          label: 'Address Line2'
        },
        address_3: {
          label: 'Address Line3'
        },
        address_4: {
          label: 'Address Line4 (Country)'
        },
        effect_date: {
          label: 'Effective Date'
        }
      },
      form_email: {
        title: 'Emails',
        buttons: {
          edit: 'Editing "{value}"',
          select: 'Select to Edit',
          update: 'Update',
          add: 'Add',
          remove: 'Remove'
        },
        email: {
          label: 'Email',
          placeholder: 'Email Address'
        },
        effect_date: {
          label: 'Effective Date'
        }
      },
      tabs: {
        names: 'Names Details',
        idens: 'HKIDs / Idens Info',
        contact: 'Contact & Basic Info',
        role: 'Roles Info',
        alerts: 'Alerts',
        alertcasepool: 'Alert Case Pool',
        attachment: 'Attachments',
        transaction: 'Transactions',
        riskAssessment: 'Risk Assessment'
      },
      msg: {
        load: {
          title: 'Load Natural Person Detail',
          success: 'Successfully Loaded',
          error: 'Load Detail Failed'
        },
        valid: {
          title: 'Validate Person Detail',
          success: 'Person detail is valid',
          error: 'Person detail is invalid'
        },
        save: {
          title: 'Save Natural Person',
          success: 'Successfully Saved',
          error: 'Save Failed',
          exception: 'Save Failed (Exception)',
          error_unique: 'Duplicate Reference ID is not allowed.'
        }
      }
    }
  },
  transaction: {
    title: 'Transaction',
    tabs: {
      new: 'New Transaction',
      edit: 'Edit Transaction',
      listing: 'History'
    },
    new: {
      steps: {
        select_tran_type: 'Select Transaction Type',
        client: 'Client Information',
        tran: 'Transaction Information',
        counterparty: 'Counterparty Information',
        remitter: 'Remitter Information',
        recipient: 'Recipient Information',
        screening: 'Screening Results',
        risk: 'Risk Assessment'
      },
      msg: {
        client_error: 'Please check the form before proceeding',
        tran_error: 'Please check the form again'
      },
      buttons: {
        continue: 'Continue',
        reset: 'Reset',
        save: 'Save All',
        cancel: 'Cancel',
        screenshot: 'Keep Screenshot',
        back: 'Back'
      },
      step1: {
        subtitles: {
          existing_client: 'Existing Client'
        },
        type: {
          label: 'Type',
          options: {
            person: 'Natural Person',
            company: 'Company'
          }
        },
        name: {
          label: 'Name'
        }
      },
      step_screening: {
        client: {
          title: 'Client Screening Results'
        },
        recipient: {
          title: 'Recipient Screening Results'
        },
        remitter: {
          title: 'Remitter Screening Results'
        }
      }
    },
    listing: {
      search: {
        label: 'Search (Tran Ref, Tran Type, Amount, Currency)'
      },
      name: {
        label: 'Name'
      },
      alert_id: {
        label: 'Alert Id'
      },
      alert_status: {
        label: 'Alert Status'
      },
      client: {
        label: 'Client'
      }
    },
    details: {
      title: 'Transaction Detail',
      client_type: {
        label: 'Client Type',
        options: {
          individual: 'Individual',
          corporate: 'Corporate'
        }
      },
      tran_date: {
        label: 'Transaction Date'
      },
      tran_type: {
        label: 'Transaction Type',
        options: [
          'Forex',
          'Inward',
          'Outward',
          'Loan'
        ],
        forex: {
          label: 'Currency Exchange',
          short_label: 'Exchange'
        },
        inward: {
          label: 'Inward Remittance',
          short_label: 'Inward'
        },
        outward: {
          label: 'Outward Remittance',
          short_label: 'Outward'
        },
        loan: {
          label: 'Money Lending',
          short_label: 'Loan'
        }
      },
      title_origin: {
        forex: 'Original Currency',
        inward: 'Origin',
        outward: 'Origin',
        loan: ''
      },
      title_dest: {
        forex: 'Target Currency',
        inward: 'Destination',
        outward: 'Destination'
      },
      fund_in_channel: {
        label: 'Fund-in Channel'
      },
      country: {
        label: 'Country'
      },
      currency: {
        label: 'Currency'
      },
      amount: {
        label: 'Amount'
      },
      fund_out_channel: {
        label: 'Fund-out Channel'
      },
      country_to: {
        label: 'Country'
      },
      currency_to: {
        label: 'Currency'
      },
      amount_to: {
        label: 'Amount'
      },
      source_of_fund: {
        label: 'Source of fund'
      },
      purpose: {
        label: 'Purpose'
      },
      tran_ref: {
        label: 'Transaction Ref.'
      },
      counterparty_nationality: {
        label: 'Counterparty Nationality'
      },
      recipient: {
        label: 'Recipient'
      },
      remitter: {
        label: 'Remitter'
      },
      remarks: {
        label: 'Remarks'
      },
      title_screen: 'Screening Results',
      hit: {
        label: 'Hit',
        options: {
          yes: 'Yes',
          no: 'No'
        }
      },
      risk_level: {
        na: 'N/A (No nationality provided)'
      },
      msg: {
        save: {
          title: 'Save Transaction',
          success: 'Successfully Saved',
          error: 'Save Failed',
          exception: 'Save Failed (Exception)'
        }
      },
      notify: {
        label: 'Must contain numbers only'
      },
      alert_case_id: {
        label: 'Alert Case ID'
      },
      alert_case_status: {
        label: 'Alert Case Status'
      },
      view_alert_case: {
        label: 'View Alert Case'
      },
      handling_fee: {
        label: 'Handling Fee'
      },
      pending_for_cdd: {
        label: 'Pending for CDD',
        options: {
          0: 'Completed CDD',
          1: 'Pending CDD'
        },
        condition: {
          purpose: 'Purpose',
          source_of_fund: 'Source of Fund',
          alert_case: 'Alert Case',
          risk_assessment: 'Risk Assessment'
        }
      },
      established_business_relationship: {
        label: 'Established Business Relationship',
        options: {
          0: 'No Business Relationship',
          1: 'Established Business Relationship'
        }
      }
    },
    statistics: {
      title: 'Transaction Statistics',
      tabs: {
        forex: 'Forex',
        remittance: 'Remittance'
      },
      buttons: {
        export: 'Export',
        edit: 'Edit',
        cancel: 'Cancel',
        save: 'Save',
        close: 'Close'
      },
      remittance: {
        inward: {
          dialog: {
            editInwardRows: 'Edit inward remittance rows'
          }
        },
        outward: {
          dialog: {
            editOutwardRows: 'Edit outward remittance rows'
          }
        },
        delivery_channel: {
          dialog: {
            editDeliveryChannels: 'Edit remittance delivery channels'
          }
        },
        customer: {
          dialog: {
            editCustomerStatistics: 'Edit customer statistics'
          }
        }
      },
      forex: {
        exchange: {
          dialog: {
            editForexRows: 'Edit forex rows'
          }
        }
      },
      risk_assessment: {
        dialog: {
          editTitle: 'Edit transaction risk statistics'
        }
      }
    }
  },
  screen: {
    single: {
      title: 'Single Screening',
      subtitle: {
        criteria: 'Criteria',
        results: 'Results'
      },
      buttons: {
        scan: 'Screen',
        loading: 'Screening...',
        view_details: 'View Screening Details',
        screenshot: 'Keep Screenshot'
      },
      risk_level: {
        label: 'Geographical Risk Level'
      },
      risk_score: {
        label: 'Geographical Risk Score'
      },
      name: {
        label: 'Name / Company Name'
      },
      nationality: {
        label: 'Nationality / Place of Incorporation'
      },
      dob: {
        label: 'Year of Birth / Date of Incorporation'
      },
      hit: {
        label: 'Hit',
        options: {
          yes: 'Yes',
          no: 'No'
        }
      },
      screened_at: {
        label: 'Screened At'
      },
      action: {
        label: 'Action'
      }
    },
    batch: {
      title: 'Batch Screening',
      type: {
        label: 'Type of screening',
        options: {
          // new: 'New created or updated records',
          // new_wl: 'All Company and Natural Person (changes in watchlist)',
          // all: 'All Company and Natural Person (full watchlist)'
          all: 'Full Screening',
          new: 'Full Screening (Newly created or updated records)',
          new_wl: 'Delta Screening',
          all_new: 'Full Screening (Newly created or updated records + Updated watchlist)'
        }
      },
      table: {
        type: {
          label: 'Type for screening',
          options: {
            company: 'Company',
            person: 'Natural Person'
          }
        },
        cnt: {
          label: 'Number of records'
        }
      },
      buttons: {
        continue: 'Continue',
        new: 'New Screening',
        pause: 'Pause',
        stop: 'Stop',
        done: 'Done',
        refresh: 'Refresh',
        auto_refresh: 'Auto Refresh'
      },
      id: {
        label: 'Batch ID'
      },
      status: {
        label: 'Status'
      },
      current_person_id: {
        label: 'Person Screening'
      },
      current_company_id: {
        label: 'Company Screening'
      },
      updated_date: {
        label: 'Last Updated'
      },
      loading: 'Loading...'
    },
    log: {
      title: 'Batch Screening Log',
      // title1: 'Batch Screening',
      table: {
        type: {
          label: 'Type'
        },
        user: {
          label: 'User'
        },
        initiator: {
          label: 'Initiator'
        },
        start_date: {
          label: 'Start Date'
        },
        duration: {
          label: 'Duration'
        },
        processed_records: {
          label: 'Processed Records'
        },
        status: {
          label: 'Status',
          option: {
            completed: 'Completed',
            failed: 'Failed',
            stop: 'Stop'
          }
        },
        action: {
          label: 'Action'
        }
      },
      save: 'Save',
      days: 'days',
      hours: 'hrs',
      minutes: 'mins',
      seconds: 'secs',
      msg: {
        retry: {
          title: 'Retry Batch Screening',
          success: 'Successfully Retried',
          error: 'Retry Failed'
        },
        stop: {
          title: 'Stop Batch Screening',
          success: 'Successfully Stopped',
          error: 'Stop Failed'
        }
      }
    },
    batchdetail: {
      title: 'Batch Screening Log Details',
      buttons: {
        save: 'download'
      },
      details: {
        reference_id: {
          label: 'Reference ID'
        },
        status: {
          label: 'Status',
          completed: 'Completed',
          paused: 'Stop',
          failed: 'Failed',
          unknown: 'Unknown'
        },
        duration: {
          label: 'Duration',
          label_unit: {
            second: 'secs',
            minute: 'mins',
            hour: 'hrs',
            day: 'days'
          },
          unit: {
            sec: 'second',
            min: 'minute',
            hour: 'hour',
            day: 'day'
          },
          connection_word: {
            label: ' and ',
            plural: 's'
          }
        },
        start_date: {
          label: 'Start Date'
        },
        end_date: {
          label: 'End Date'
        },
        processed_record: {
          label: 'Processed Record'
        },
        initiator: {
          label: 'Initiator'
        },
        alert_generated: {
          label: 'Alert Generated'
        },
        companies: {
          label: 'Companies'
        },
        person: {
          label: 'Natural Persons'
        }
      },
      table: {
        header: {
          col_1: 'ID Number/ Company No.',
          col_2: 'Name',
          col_3: 'Alert ID',
          entityIds: 'Entity Ids'
        }
      }
    },
    ongoing: {
      title: 'Ongoing Screening',
      subtitle: 'Ongoing Screening assist you to find out geographical risk updates in your client',
      lastScreen: 'Last Screen Date: {date}',
      buttons: {
        delta: {
          label: 'Run Delta Screening'
        },
        full: {
          title: 'Full Screening',
          subtitle: 'Screen all of your clients against watchlist'
        },
        selective: {
          title: 'Selective Screening',
          subtitle: 'Screen specific clients against watchlist'
        },
        schedule: {
          title: 'Scheduled Screening',
          subtitle: 'Delta screen all client changes and watchlist changes at a specific time slot'
        }
      },
      schedule: {
        status: {
          label: 'Status'
        },
        timeslot: {
          label: 'Scheduled Timeslot'
        },
        next: {
          label: 'Next Screening Date'
        }
      }
    }
  },

  // ewe screening
  ewe_screen: {
    title: 'Onboarding Screening',
    form: {
      type: {
        options: {
          individual: 'Individual',
          corporate: 'Corporate'
        }
      },
      ref_id: {
        label: 'Reference ID'
      },
      name: {
        label: 'Name'
      },
      gender: {
        label: 'Gender',
        labelPlural: 'Genders',
        options: {
          empty: '- Select -',
          male: 'Male',
          female: 'Female',
          others: 'Others'
        }
      },
      dob: {
        label: 'Date of Birth'
      },
      country: {
        label: 'Country',
        labelPlural: 'Countries'
      },
      categories: {
        label: 'Categories',
        labelPlural: 'Categories'
      },
      screening_lists: {
        label: 'Screening Lists',
        labelPlural: 'Screening Lists'
      },
      btn: {
        search: {
          label: 'Search'
        }
      }
    },
    result: {
      title: 'Result',
      table: {
        scan_no: {
          label: 'Scan No'
        },
        fieldset: {
          title: 'Search Criteria',
          entityType: {
            label: 'Entity Type'
          },
          name: {
            label: 'Name'
          },
          dob: {
            label: 'Date of Birth'
          },
          yob: {
            label: 'Year of Birth'
          },
          country: {
            label: 'Country',
            all: 'All Countries'
          },
          gender: {
            label: 'Gender',
            all: 'All Genders'
          },
          category: {
            label: 'Category',
            all: 'All Categories'
          },
          screening_list: {
            label: 'Screening List'
          }
        }
      },
      btn: {
        save: {
          label: 'Save'
        },
        onboard: {
          label: 'Onboard'
        },
        viewClient: {
          label: 'View Client'
        },
        viewAlertCase: {
          label: 'View Alert Case'
        },
        getKYB: {
          label: 'Get KYB Report'
        }
      }
    },
    entities_table: {
      header: {
        type: 'Type',
        name: 'Name',
        similarity: 'Name Similarity',
        portrait: 'Potrait',
        category: 'Category',
        dob: 'DOB',
        doi: 'DOI',
        country: 'Country'
      },
      column: {
        entityId: {
          label: 'Entity ID'
        },
        similarity: {
          exact: 'Exact',
          strong: 'Strong',
          weak: 'Weak'
        }
      }
    }
  },
  alert_case: {
    title: 'Alert Case Pool',
    buttons: {},
    table: {
      search: {
        label: 'Search'
      },
      filter: {
        deleted_client: 'Deleted Client',
        show_deleted_clients: 'Show Deleted Client Only',
        show_true_hit: 'Show True Hit Only'
      },
      header: {
        id: {
          label: 'Case ID'
        },
        last_hit_at: {
          label: 'Hit Date'
        },
        client_id: {
          label: 'Client ID'
        },
        name: {
          label: 'Name'
        },
        status: {
          label: 'Status',
          options: {
            pending: 'Pending',
            resolved: 'Resolved'
          }
        },
        cnt_pending: {
          label: 'Pending Cases'
        },
        action: {
          label: 'Action'
        }
      }
    }
  },
  alert_case_details: {
    title: 'Case #{case_id}',
    table: {
      headers: {
        entity_type: {
          label: 'Type'
        },
        entity_name: {
          label: 'Name'
        },
        entity_picture: {
          label: 'Portrait'
        },
        entity_categories: {
          label: 'Category'
        },
        entity_dob: {
          label: 'DOB/DOI'
        },
        entity_countries: {
          label: 'Country'
        },
        status: {
          label: 'Status',
          options: {
            pending: 'Pending',
            true: 'True Hit',
            false: 'False Hit'
          }
        }
      }
    },
    tabs: {
      investigation: 'Investigation'
    },
    updatedBy: 'Updated By'
  },
  audit: {
    log: {
      title: 'Audit Log',
      buttons: {
        reset: 'Reset',
        apply: 'Apply',
        download: 'Download'
      },
      table: {
        headers: {
          date: 'Date',
          severity: 'Severity',
          activity: 'Activity',
          user: 'User'
        },
        filters: {
          date: {
            label: 'Select Date'
          },
          types: {
            default: 'All Types',
            system: 'System',
            naturalperson: 'Natural Person',
            company: 'Company',
            transaction: 'Transactions',
            alert: 'Alerts',
            namescreening: 'Name Screening',
            dataimport: 'Data Import',
            ongoingscreening: 'Ongoing Screening'
          },
          severity: {
            default: 'All Severity',
            normal: 'Normal',
            medium: 'Medium',
            high: 'High'
          },
          user: {
            default: 'All Users'
          }
        }
      }
    }
  },

  user: {
    action: {
      naturalperson: {
        title: 'Natural Person',
        create: {
          subtitle: 'Create',
          statement: 'Created Natural Person Record #{id}'
        },
        update: {
          subtitle: 'Update',
          statement: 'Updated Natural Person Record #{id}'
        },
        delete: {
          subtitle: 'Delete',
          statement: 'Deleted Natural Person Record #{id}'
        },
        export: {
          subtitle: 'Export',
          statement: 'Exported {doc_type} for Natural Person Record #{id}'
        }
      },

      company: {
        title: 'Company',
        create: {
          subtitle: 'Create',
          statement: 'Created Company Record #{id}'
        },
        update: {
          subtitle: 'Update',
          statement: 'Updated Company Record #{id}'
        },
        delete: {
          subtitle: 'Delete',
          statement: 'Deleted Company Record #{id}'
        },
        export: {
          subtitle: 'Export',
          statement: 'Exported #{doc_type} for Company Record #{id}'
        }

      },

      transaction: {
        title: 'Transaction',
        create: {
          subtitle: 'Create',
          statement: 'Created Transaction Record #{ref_id}'
        },
        update: {
          subtitle: 'Update',
          statement: 'Updated Transaction Record #{ref_id}'
        },
        delete: {
          subtitle: 'Delete',
          statement: 'Deleted Transaction Record #{ref_id}'
        },
        download: {
          subtitle: 'Download',
          statement: 'Download MSO form #{ref_id}'
        }
      },

      alert: {
        title: 'Alert',
        resolve: {
          subtitle: 'Resolve',
          statement: 'Resolved Alert Case #{ref_id}'
        },
        modify: {
          subtitle: 'Modify',
          statement: 'Modified Alert Case #{ref_id}'
        }
      },

      name_screening: {
        title: 'Name Screening',
        single: {
          subtitle: 'Single Name Screening',
          statement: 'Performed Name Screening with ({name}, {nationality}, {yob})'
        },
        onboarding: {
          subtitle: 'Onboarding Screening',
          statement: 'Performed Onboarding Screening \ninputs(name: <i>{name}</i>, entity type: <i>{entity_type}</i>, year of birth: <i>{year_of_birth}</i>, countries: <i>{countries}</i>, gender: <i>{gender}</i>, categories: <i>{categories}</i>) \nresults(hit: <i>{hit}</i>)'
        },
        batch: {
          subtitle: 'Batch Name Screening',
          start: {
            status: 'Start',
            statement: 'Started Batch Screening Job #{ref_id}'
          },
          stop: {
            status: 'Stop',
            statement: 'Stopped Batch Screening Job #{ref_id}'
          },
          end: {
            status: 'End',
            statement: 'Ended Batch Screening Job #{ref_id}'
          },
          export: {
            subtitle: 'Export',
            statement: 'Exported Batch Screening Report for Batch Screening Job #{ref_id}'
          }
        }

      },

      import: {
        title: 'Data Import',
        naturalperson: {
          subtitle: 'Natural Person',
          statement: 'Imported Natural Person'
        },
        company: {
          subtitle: 'Company',
          statement: 'Imported Company'
        }
      },

      other: {
        title: 'Others'
      },

      ongoing_screening: {
        task: {
          title: 'Ongoing Screening',
          download: {
            outputs: {
              statement: 'Download the Ongoing Screening\'s Results #{taskId}',
              subtitle: 'Download Results'
            },
            inputs: {
              statement: 'Download the Ongoing Screening\'s Inputs #{taskId}',
              subtitle: 'Download Inputs'
            }
          },
          start: {
            statement: 'Performed Ongoing Screening #{taskId}',
            subtitle: 'Start'
          },
          stop: {
            statement: 'Stopped Ongoing Screening #{taskId}',
            subtitle: 'Stop'
          },
          import: {
            statement: 'Imported Ongoing Screening Result #{taskId}',
            subtitle: 'Import'
          }
        },
        webhook: {
          title: 'Webhook',
          resend: {
            statement: 'Resend Webhook Event #{event}',
            subtitle: 'Resend'
          },
          register: {
            statement: 'Register New Webhook #{webhookId}',
            subtitle: 'Register'
          },
          update: {
            statement: 'Updated Webhook #{webhookId}',
            subtitle: 'Update'
          },
          unregister: {
            statement: 'Unregister Webhook #{webhookId}',
            subtitle: 'Unregister'
          }
        },
        single: {
          statement: 'Ongoing Screening (Single)\ninputs(names: <i>{names}</i>, entity type: <i>{entity_type}</i>, year of birth: <i>{year_of_birth}</i>, countries: <i>{countries}</i>, gender: <i>{gender}</i>, ref_id: <i>{ref_id}</i>) \nresults(hit: <i>{hit}</i>)'
        }
      },
      system: {
        config: {
          title: 'System Configuration',
          update: {
            subtitle: 'System Configuration Update',
            statement: 'Updated system configuration <i>{config_key}</i> to <i>{config_value}</i>'
          }
        }
      }
    }
  },

  ekyc: {
    listing: {
      title: 'eKYC Alliance',
      buttons: {
        add: 'New Request'
      },
      table: {
        id: {
          label: 'Client ID'
        },
        name: {
          label: 'Company Name'
        },
        brNumber: {
          label: 'BR Number'
        },
        fileCount: {
          label: 'Files'
        },
        requestCount: {
          label: 'Requests'
        }
      }
    },
    listing_doc: {
      table: {
        name: {
          label: 'Name'
        },
        description: {
          label: 'Description'
        },
        uploaded_at: {
          label: 'Upload Date'
        },
        mime_type: {
          label: 'Type'
        }
      }
    },
    listing_req: {
      table: {
        bank_name: {
          label: 'Bank Name'
        },
        status: {
          label: 'Status'
        },
        request_date: {
          label: 'Request Date'
        },
        message: {
          label: 'Message'
        }
      }
    },
    new: {
      title: 'New Request',
      steps: {
        company: {
          label: 'Select Company'
        },
        file: {
          label: 'Sync Files'
        },
        bank: {
          label: 'Select Banks'
        }
      }
    },
    details: {
      title: 'New Request'
    }
  },
  attachment: {
    listing: {
      title: 'Attachment',
      buttons: {
        add: 'Upload New File',
        preview: 'Preview',
        download: 'Download',
        upload: 'Upload'
      },
      table: {
        file_name: {
          label: 'File Name'
        },
        description: {
          label: 'Description'
        },
        create_date: {
          label: 'Upload Date'
        },
        file_mime: {
          label: 'Type'
        }
      }
    }
  },
  dialogs: {
    delete_confirm: {
      title: 'Delete Confirmation',
      text: 'Are you sure to delete this record?',
      buttons: {
        yes: 'Yes, delete',
        no: 'No'
      }
    },
    logout_confirm: {
      title: 'Logout Confirmation',
      text: 'Are you sure you want to logout?',
      buttons: {
        yes: 'Yes',
        no: 'No'
      }
    },
    alert_unlock: {
      title: 'Re-open Case Confirmation',
      text: 'The alert has been processed before. Are you sure to reopen the case?',
      buttons: {
        yes: 'Yes',
        no: 'No'
      }
    },
    member: {
      title: 'Member / Officer Info',
      buttons: {
        update: 'Update',
        close: 'Close'
      },
      form: {
        type: {
          label: 'Type',
          options: {
            person: 'Natural Person',
            company: 'Company'
          }
        },
        roles: {
          label: 'Roles',
          options: {
            founder: 'Founder',
            shareholder: 'Shareholder',
            director: 'Director',
            secretary: 'Secretary',
            auth_rep: 'Authorised Representatives',
            significant_controller: 'Significant Controller'
          }
        }
      },
      form_share: {
        title: 'Share Capital to be Subscribed',
        buttons: {
          add: 'Add',
          remove: 'Remove'
        },
        type: {
          label: 'Class of Shares (e.g. Ordinary／Preference etc.)'
        },
        shares_num: {
          label: 'Total Number'
        },
        currency: {
          label: 'Currency'
        },
        shares_amount: {
          label: 'Total Amount'
        },
        rights: {
          label: 'Particulars of Rights Attached'
        }
      },
      form_director: {
        director_type: {
          label: 'Director Type',
          options: {
            1: 'Director',
            2: 'Alternate Director',
            3: 'Reserve Director',
            4: 'Director & Alternate Director'
          }
        },
        alternate_to_id: {
          label: 'Alternate to'
        },
        start_date: {
          label: 'Date of Appointment'
        },
        consent: {
          label: 'Consent',
          options: {
            1: 'Yes',
            2: 'Later'
          }
        },
        is_end_status: {
          label: 'Is Cessation'
        },
        end_reason: {
          label: 'Reason for Cessation',
          options: {
            1: 'Resignation/Others',
            2: 'Deceased'
          }
        },
        end_date: {
          label: 'Date of Cessation'
        }
      },
      form_secretary: {
        start_date: {
          label: 'Start Date'
        },
        end_date: {
          label: 'End Date'
        }
      },
      form_auth_rep: {
        start_date: {
          label: 'Date of Appointment'
        }
      },
      form_controller: {
        control_nature: {
          label: 'Control Nature'
        },
        commencement_date: {
          label: 'Commencement Date'
        }
      }
    },
    new_version_released: {
      title: '🎉 New Enhancements Released! 🎉',
      text: 'click "Refresh" to enjoy the latest enhancements.',
      buttons: {
        update: 'Refresh',
        later: 'Later'
      },
      confirm: {
        title: 'Ready to refresh?',
        text: 'Please make sure your works has been saved before refreshing.',
        buttons: {
          yes: 'Yes, I am ready',
          cancel: 'No, I want to save first'
        }
      }
    },
    screeningDetail: {
      entityID: 'Entity Id',
      entityType: {
        label: 'Entity Type',
        individual: 'Individual',
        corporate: 'Corporate'
      },
      buttons: {
        close: 'Close',
        export: 'Export'
      },
      general: {
        _title: 'General Information',
        businessName: {
          label: 'Business Name'
        },
        title: {
          label: 'Title'
        },
        firstName: {
          label: 'First Name'
        },
        middleName: {
          label: 'Middle Name'
        },
        middlename: {
          label: 'Middle Name'
        },
        lastName: {
          label: 'Last Name'
        },
        gender: {
          label: 'Gender'
        },
        country: {
          label: 'Country'
        },
        dateOfBirth: {
          label: 'Date of Birth'
        },
        dateOfDeath: {
          label: 'Date of Death'
        }
      },
      softDelete: 'Deleted',
      contact: {
        title: 'Contact Information',
        businessPhone: {
          label: 'Business Phone'
        },
        fax: {
          label: 'Fax'
        },
        website: {
          label: 'Website'
        },
        homePhone: {
          label: 'Home Phone'
        },
        mobilePhone: {
          label: 'Mobile Phone'
        },
        email: {
          label: 'Email'
        }
      },
      name: {
        title: 'Name Information',
        primaryName: 'Primary Name',
        aka: 'aka.'
      },
      identifier: {
        title: 'ID Information'
      },
      address: {
        title: 'Address Information'
      },
      association: {
        title: 'Associations'
      },
      note: {
        title: 'Notes'
      },
      article: {
        title: 'Articles',
        table: {
          originalUrl: 'Original Url',
          c6Url: 'C6 Url',
          category: 'Category'
        }
      },
      politicalPosition: {
        title: 'Political Positions'
      },
      sanction: {
        title: 'Sanctions',
        inactive: 'Inactive'
      }
    },
    externalUrlConfirm: {
      title: 'Access to 3rd-party website',
      text: 'This link will take you to 3rd-party website. <br>Please be aware that the website is not managed by us.',
      buttons: {
        ignore: 'Don\'t show me again',
        continue: 'Let me go',
        stay: 'Stay here'
      }
    },
    crPDFsGenerator: {
      title: 'Generate Companies Registry PDF',
      buttons: {
        download: 'Download',
        nominate: 'Nominate',
        suspend: 'Suspend'
      },
      catalog: {
        label: 'Catalog',
        options: {
          create: 'Company Creation',
          change: 'Change of Company Secretary/Director',
          updateInfo: 'Update information of Company Secretary/Director'
        }
      },
      forms: {
        label: 'Form',
        options: {
          NNC1: 'Incorporation Form (Company Limited by Shares)',
          NNC1G: 'Incorporation Form (Company Not Limited by Shares)',
          NN1: 'Application for Registration as Registered Non-Hong Kong Company',
          IRBR1: 'Notice to Business Registration Office',
          IRBR2: 'Notice to Business Registration Office',
          ND2A: 'Notice of Change of Company Secretary and Director (Appointment/Cessation)',
          ND5: 'Notice of Change of Reserve Director (Nomination/Cessation)',
          NN6: 'Return of Change of Company Secretary and Director of Registered Non-Hong Kong Company (Appointment/Cessation)',
          NN8: 'Return of Change of Authorized Representative of Registered Non-Hong Kong Company (Appointment/Cessation)',
          ND2B: 'Notice of Change in Particulars of Company Secretary and Director',
          ND7: 'Notice of Change in Particulars of Reserve Director',
          NN7: 'Return of Change in Particulars of Company Secretary and Director of Registered Non-Hong Kong Company',
          NN8C: 'Return of Change in Particulars of Authorized Representative of Registered Non-Hong Kong Company'
        }
      },
      director: {
        label: 'Director'
      },
      reserveDirector: {
        label: 'Reserve Director'
      },
      alternateDirector: {
        label: 'Alternate Director'
      },
      secretary: {
        label: 'Secretary'
      },
      authRep: {
        label: 'Authorized Representative'
      },
      noRecords: 'No available records.'
    },
    fullBatchScreeningConfirm: {
      title: 'Confirm to trigger Full Screening?',
      text: 'It is not recommended to perform this every day. Since this action will screen all clients and generate massive alerts.',
      actions: {
        yes: 'Yes, please continue',
        no: 'No'
      }
    },
    webhook: {
      title: 'Webhook Details',
      buttons: {
        save: 'Save',
        cancel: 'Cancel'
      }
    },
    webhooklog: {
      buttons: {
        resend: 'Resend'
      }
    },
    webhookHowToUse: {
      title: 'How to verify the signature?',
      requestHeaders: {
        title: 'Every notification will carry the below headers:',
        wid: 'the id of the webhook which subscribed to specific events.',
        time: 'the timestamp when the notification is emitted.',
        sid: 'the unique session id of the notification.',
        sig: 'The asymmetric signature of the notification generated by RBA Essential.'
      },
      patterns: {
        title: 'The signature is generated by the below pattern:',
        checksum: 'by hashing the request body in JSON format with <code>MD5</code>.',
        algorithm: '<code>RSA</code> with <code>SHA512</code> is used as the Digital Signature Algorithm.'
      },
      example: {
        title: 'Example in Javascript:'
      }
    },
    onboarding: {
      title: 'Onboarding New Client',
      buttons: {
        save: 'Confirm'
      }
    },
    select_existing_client: {
      title: 'Select Existing Client',
      buttons: {
        save: 'Select'
      },
      search: {
        individual: {
          label: 'Search by Name, Identity, Ref Id'
        },
        corporate: {
          label: 'Search by Name, Identity, Ref Id'
        }
      },
      table: {
        headers: {
          coi_number: 'COI Number',
          name: 'Name',
          identity: 'Identity',
          ref_id: 'Ref ID',
          gender: 'Gender',
          dob: 'Date of Birth'
        }
      }
    }
  },
  listing: {
    table: {
      action: {
        label: 'Action'
      },
      datepicker: {
        today: 'Today',
        yesterday: 'Yesterday',
        last_n_days: 'Last {num_of_days} Days',
        this_month: 'This Month',
        last_month: 'Last Month'
      },
      // filter: {
      //     list: {
      //         label: 'Filter'
      //     },
      //     text: {
      //         label: 'Filter'
      //     },
      //     date: {
      //         label: 'Filter'
      //     }
      // },
      datefilter: {
        apply: 'Apply'
      },
      texts: {
        count: 'Showing {from} to {to} of {count} records|{count} records|One record',
        first: 'First',
        last: 'Last',
        filter: 'Filter:',
        filterPlaceholder: 'Search query',
        limit: 'Per Page:',
        page: 'Page:',
        noResults: 'No matching records',
        noRequest: 'Please select at least one filter to fetch results',
        filterBy: 'Filter',
        loading: 'Loading...',
        defaultOption: 'Select {column}',
        columns: 'Columns'
      }
    }
  },
  import: {
    title: 'Data Import',
    type: {
      label: 'Type',
      options: {
        person: 'Natural Person',
        company: 'Company'
      }
    },
    buttons: {
      select: 'Select File',
      start: 'Import',
      download_template: 'Template File'
    },
    msg: {
      upload: {
        title: 'Data Import',
        success: 'The file uploaded successfully',
        error: 'Failed to upload file'
      }
    }
  },
  export: {
    title: 'Data Export'
  },
  alertCase: {
    title: 'Alert Case',
    buttons: {
      refresh: 'Refresh',
      export: 'Export',
      bulk_action: 'Bulk Action'
    }
  },
  risk_assessment: {
    title: 'Risk Assessment',
    buttons: {
      complete: 'Perform Risk Assessment',
      save: 'Save',
      details: 'Details'
    },
    msg: {
      save: {
        title: 'Risk Assessment',
        success: 'Risk Assessment saved successfully',
        error: 'Failed to save Risk Assessment'
      }
    },
    form: {
      title: 'Risk Assessment Questionnaire',
      risk_level: {
        label: 'Risk Level'
      },
      risk_score: {
        label: 'Risk Score'
      },
      create_date: {
        label: 'Create Date'
      },
      select_risk_model: 'Select Risk Model',
      cancel: 'Cancel',
      error_load_failed: 'Failed to load risk assessments'
    },
    question: 'Question',
    answer: 'Answer',
    category_label: 'Risk Assessment Category',
    calculating: 'Calculating...',
    total_score: 'Total Score: {score}',
    min_label: 'Min: {score}',
    max_label: 'Max: {score}',
    scale_spectrum: 'Scale Spectrum',
    scale_legend: 'Scale Legend:',
    default_fallback_text: 'Current calculated location relative to baseline compliance risk scale.',
    show_weight_impact: 'Show Weight Impact',
    section_weight: 'Section Weight: {ratio}%',
    of_total: 'of total',
    table: {
      question_parameters: 'Question Parameters',
      collected_response_data: 'Collected Response Data',
      weight_impact: 'Weight Impact',
      assigned_score: 'Assigned Score:'
    },
    tooltip: {
      title: 'Total Score Calculation Formula:',
      formula: 'Total Score = ∑ (Factor Scores)',
      description: 'Where each active factor score is determined by multiplying its compiled question score metrics against the overall system weight parameters.'
    }
  },
  report: {
    actions: {
      print: 'Print',
      exportPDF: 'Export PDF'
    },
    footer: {
      page: 'Page',
      organization: 'Organization',
      exportedBy: 'Exported By',
      exportedAt: 'Exported At'
    },
    screening: {
      header: {
        title: 'Screening Report'
      },
      info: {
        title: 'Screening Information',
        screeningID: 'Screening ID',
        screeningAt: 'Screening At',
        screeningBy: 'Screening By',
        engine: 'Screening Engine'
      },
      criteria: {
        title: 'Screening Criteria',
        name: 'Name',
        entityType: 'Entity Type',
        DOB: 'Date of Birth',
        YOB: 'Year of Birth',
        gender: {
          label: 'Gender',
          all: 'All Genders'
        },
        country: {
          label: 'Country',
          all: 'All Countries (Total 250+ Countries)',
          more: '+{count} more countries'
        },
        category: {
          label: 'Category',
          all: 'All Categories (Total 10+ Categories)',
          more: '+{count} more categories'
        }
      },
      results: {
        title: 'Screening Result',
        count: 'Number of Hit',
        riskScore: 'Geographical Risk Score',
        riskLevel: 'Geographical Risk Level',
        declaration: 'Declaration',
        declarationPlaceholder: 'Please input the declaration here...',
        editDeclaration: 'Edit the declaration',
        addDeclaration: 'Add the declaration',
        saveDeclaration: 'Save the declaration',
        cancelDeclaration: 'Cancel the declaration'
      }
    },
    screeningEntity: {
      deleted: '(Deleted)',
      similarity: {
        label: 'Name Similarity',
        exact: 'Exact',
        strong: 'Strong',
        weak: 'Weak'
      },
      address: {
        location: 'Location'
      },
      note: {
        source: 'Source',
        content: 'Content'
      },
      association: {
        name: 'Name',
        type: 'Type',
        id: 'ID',
        description: 'Description'
      },
      article: {
        url: 'URL',
        category: 'Category',
        backupUrl: 'Backup URL'
      },
      politicalPosition: {
        country: 'Country',
        duration: 'Duration',
        position: 'Position'
      },
      sanction: {
        sanctionList: 'Sanction List',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive'
      }
    },
    alertCase: {
      header: {
        clientReference: 'Client Ref.',
        caseID: 'Case ID'
      },
      coverPage: {
        title: 'AML REPORT',
        clientReference: 'Ref.',
        caseID: 'Case ID'
      },
      clientDetails: {
        clientProfileInd: 'Client Profile (Individual)',
        clientProfileOrg: 'Client Profile (Organization)',
        clientInfo: 'Client Information',
        engName: 'English Name',
        chiName: 'Chinese Name',
        gender: 'Gender',
        nationality: 'Nationality',
        dateOfBirth: 'Date of Birth',
        nameType: 'Name Type',
        nameTypeEnglishAlias: 'English Alias',
        nameTypeChineseAlias: 'Chinese Alias',
        nameTypeEnglishPrimary: 'English Primary',
        nameTypeChinesePrimary: 'Chinese Primary',
        name: 'Name',
        effectDate: 'Effect Date',
        idDocInfo: 'ID Document Information',
        idType: 'ID Type',
        country: 'Country',
        idNumber: 'ID Number',
        expiryDate: 'Expiry Date',
        contactInfo: 'Contact Information',
        telephone: 'Telephone',
        fax: 'Fax',
        type: 'Type',
        address: 'Address',
        addressType: 'Address Type',
        addressLine: 'Address Line',
        createdAt: 'Created At',
        updatedAt: 'Updated At'
      },
      caseDetails: {
        screeningProfile: 'Screening Profile',
        screeningInfo: 'Screening Information',
        lastScreenedAt: 'Last Screened At',
        screenedBy: 'Screened By',
        screeningCriteria: 'Screening Criteria',
        name: 'Name',
        entityType: 'Entity Type',
        yearOfBirth: 'Year of Birth',
        gender: 'Gender',
        country: 'Country',
        category: 'Category',
        caseInfo: 'Case Information',
        numOfHit: 'Number of Hit',
        riskScore: 'Geographical Risk Score',
        riskLevel: 'Geographical Risk Level',
        pendingCase: 'Pending Case',
        trueCase: 'True Case',
        falseCase: 'False Case'
      },
      caseEntity: {
        entityID: 'Entity ID',
        alertHitInfo: 'Alert Hit Information',
        alertStatus: 'Alert Status',
        lastUpdateDate: 'Last Update Date',
        exposition: 'Exposition',
        remarks: 'Remarks'
      }
    },
    transactionStatistics: {
      coverPage: {
        title: 'Transaction Statistics Report',
        reportPeriod: 'Report Period'
      },
      header: {
        reportPeriod: 'Report Period'
      },
      riskStatistics: {
        title: 'Transaction Risk Statistics',
        categoryBreakdown: 'Risk Category Breakdown',
        totalDueDiligence: 'Total {transactionType} transactions requiring due diligence:',
        rejectionRate: 'Rejection rate of screened transactions:',
        rejectedCasesDescription: '# Rejected cases: transactions declined due to failed CDD/EDD checks, sanctions screening, or suspicious activity concerns, prior to completion.',
        cdd: 'CDD',
        edd: 'EDD',
        rejected: 'Rejected',
        customerDueDiligence: 'Customer Due Diligence',
        enhancedDueDiligence: 'Enhanced Due Diligence',
        rejectedTransactions: 'Rejected Transactions',
        cddConducted: 'CDD conducted',
        eddConducted: 'EDD conducted',
        rejectedCases: 'Rejected cases',
        transactionTypes: {
          forex: 'Forex',
          remittance: 'Remittance'
        }
      },
      remittanceStatistics: {
        inwardRemittancePercentage: 'Inward remittance percentage',
        outwardRemittancePercentage: 'Outward remittance percentage',
        naturalPersonPercentage: 'Natural Person percentage',
        totalHandlingFee: 'Total Handling Fee (HKD)',
        amountAcrossTransactions: '{amount} HKD across {count} transactions',
        naturalPersonCompanyCaption: '{person} (Natural Person), {company} (Company)',
        handlingFeeCaption: '{outward} (Outward), {inward} (Inward)',
        channel: 'Channel',
        inward: 'Inward',
        outward: 'Outward',
        inwardPercentage: '% Inward',
        outwardPercentage: '% Outward',
        total: 'Total',
        percentage: 'Percentage (%)',
        currency: 'Currency',
        amountHKD: 'Amount (HKD)',
        transactionCount: 'No. of transactions',
        customerType: 'Customer Type',
        naturalPerson: 'Natural Person',
        company: 'Company',
        handlingFeeHKD: 'Handling Fee (HKD)',
        shareOfTotalAmount: 'Share of total amount',
        othersCurrencies: 'Others ({count} currencies)',
        customerCount: 'Customer Count',
        amountTooltip: '{label} (HKD): {amount}',
        noDeliveryChannelData: 'No delivery channel data available.',
        deliveryChannelChartAriaLabel: 'Inward and outward remittance percentages by delivery channel',
        noCustomerData: 'No customer data available.',
        customerChartAriaLabel: 'Inward and outward remittance customers by customer type',
        noOutwardRemittanceData: 'No outward remittance data available.',
        noInwardRemittanceData: 'No inward remittance data available.'
      },
      forexStatistics: {
        totalPurchasesHKD: 'Total purchases (HKD)',
        totalSalesHKD: 'Total sales (HKD)',
        netPositionHKD: 'Net position (HKD)',
        currenciesOnReturn: 'Currencies on return',
        transactionsCount: '{count} transactions',
        purchasesMinusSales: 'Purchases − Sales',
        top5ShownOthers: 'Top 5 shown + Others',
        top5CurrenciesOthers: 'Top 5 currencies + Others',
        currency: 'Currency',
        purchaseAmountHKD: 'Purchase amount (HKD)',
        purchaseTransactions: 'Purchase transactions',
        saleAmountHKD: 'Sale amount (HKD)',
        saleTransactions: 'Sale transactions',
        totalAmountHKD: 'Total amount (HKD)',
        shareOfTotal: 'Share of total',
        purchaseVsSaleAmountByCurrency: 'Purchase vs sale amount by currency (HKD)',
        shareOfTotalTransactionCount: 'Share of total transaction count',
        rankByAmount: 'Rank by amount',
        rankByTransactions: 'Rank by transactions',
        othersCurrencies: 'Others ({count} currencies)',
        purchaseHKD: 'Purchase (HKD)',
        saleHKD: 'Sale (HKD)',
        purchase: 'Purchase',
        sale: 'Sale',
        noTransactionData: 'No transaction data available.',
        purchaseSaleAriaLabel: 'Purchase and sale amounts by currency',
        amountTooltip: '{label}: {amount}',
        purchaseAmount: 'Purchase amount',
        purchaseCount: 'Purchase count',
        saleAmount: 'Sale amount',
        saleCount: 'Sale count'
      },
      forexReport: {
        title: 'Forex Transaction Report',
        section: {
          topCurrencyPlusOthers: 'Top 5 Forex Currencies + Others',
          transactionRisk: 'Forex Transaction Risk Statistics'
        },
        table: {
          headers: {
            date: 'Date',
            currencyPair: 'Currency Pair',
            totalVolume: 'Total Volume',
            totalCount: 'Total Count',
            avgVolume: 'Average Volume',
            avgCount: 'Average Count'
          }
        }
      },
      remittanceReport: {
        title: 'Remittance Transaction Report',
        deliveryChannelOptions: {
          MSO: 'Through other money service operators',
          FINS: 'Through Financial Institution (e.g. Bank)',
          CBAL: 'Counter balance within customers in the company',
          OTH: 'Others'
        },
        customerTypeOptions: {
          CMPNY: 'Company',
          LOCAL: 'Local Resident',
          FORGN: 'Non-local Resident'
        },
        section: {
          deliveryChannel: 'Remittance Delivery Channel',
          typeOfCustomer: 'Type of Customers',
          outwardRemittance: 'Top 5 Outward Remittance + Others',
          inwardRemittance: 'Top 5 Inward Remittance + Others',
          transactionRisk: 'Remittance Transaction Risk Statistics'
        },
        table: {
          headers: {
            date: 'Date',
            currencyPair: 'Currency Pair',
            totalVolume: 'Total Volume',
            totalCount: 'Total Count',
            avgVolume: 'Average Volume',
            avgCount: 'Average Count'
          }
        }
      }
    }
  },
  webhook: {
    listing: {
      title: 'Webhook',
      buttons: {
        add: 'Register'
      },
      table: {
        guid: {
          label: 'Id'
        }
      }
    },
    details: {
      form: {
        url: {
          label: 'Url'
        },
        eventTypes: {
          label: 'Event Types',
          helps: {
            subtitle: {
              STATUS_CHANGE: 'You will be notified of every update on the ongoing task status.',
              STATUS_COMPLETED: 'You will be notified of every completed ongoing task.',
              ALERT_GENERATED: 'You will be notified of every ongoing task which had generated alerts.'
            },
            text: {
              STATUS_CHANGE: 'You will receive <code>TaskGuid</code>, <code>TaskStatus</code>, and <code>ResultDownloadToken</code> as body payload.<br><code>TaskGuid</code> - The unqiue id of ongoing task.<br><code>TaskStatus</code> - The task status (e.g. <code>completed</code>, <code>failed</code>, <code>timeout</code> .etc).<br><code>ResultDownloadToken</code> - The token for downloading results file. That will be valid within 15 mins from it is generated and appear only on task <code>completed</code>.',
              STATUS_COMPLETED: 'You will receive <code>TaskGuid</code>, <code>TaskStatus</code>, and <code>ResultDownloadToken</code> as body payload.<br><code>TaskGuid</code> - The unqiue id of ongoing task.<br><code>TaskStatus</code> - The task status (e.g. <code>completed</code>, <code>failed</code>, <code>timeout</code> .etc).<br><code>ResultDownloadToken</code> - The token for downloading results file. That will be valid within 15 mins from it is generated.',
              ALERT_GENERATED: 'You will receive <code>TaskGuid</code>, and <code>TaskStatus</code> as body payload.<br><code>TaskGuid</code> - The unqiue id of ongoing task.<br><code>TaskStatus</code> - The task status (e.g. <code>completed</code>, <code>failed</code>, <code>timeout</code> .etc).'
            }
          }
        },
        publicKey: {
          label: 'Public Key',
          buttons: {
            show: 'Show',
            hide: 'Hide',
            copy: 'Copy',
            howToUse: 'How to use?'
          },
          remarks: 'The public key helps verify the signature of notification from RBA Essential.'
        }
      }
    },
    log: {
      title: 'Webhook Log',
      search: {
        eventType: {
          label: 'Event Type'
        },
        dates: {
          label: 'Dates'
        }
      },
      header: {
        time: {
          label: 'Time'
        },
        data: {
          label: 'Data'
        }
      },
      detail: {
        title: 'Webhook Log Details',
        guid: {
          label: 'Id'
        },
        url: {
          label: 'Url'
        },
        eventType: {
          label: 'Event Type'
        },
        dataType: {
          label: 'Data Type'
        },
        data: {
          label: 'Data'
        },
        isAck: {
          label: 'Acknowledgment'
        },
        createdDatetime: {
          label: 'Created'
        },
        modifiedDatetime: {
          label: 'Updated'
        }
      }
    }
  },
  settings: {
    title: 'Settings',
    buttons: {
      save: 'Save'
    },
    notification: {
      success: {
        title: 'Success',
        text: 'Settings saved successfully'
      },
      error: {
        title: 'Error',
        text: 'Failed to save settings'
      }
    },
    validation: {
      email: {
        required: 'Email is required',
        invalid: 'Invalid email format'
      }
    },
    groups: {
      ongoing_screening: {
        title: 'Ongoing Screening',
        auto_resolve: {
          true_hit: {
            title: 'Auto Resolve True Hit',
            subtitle: 'Ignore all updates on related entity that marked as TRUE hit.'
          },
          false_hit: {
            title: 'Auto Resolve False Hit',
            subtitle: 'Ignore all updates on related entity that marked as FALSE hit.'
          }
        },
        notify_new_alerts: {
          title: 'Notify New Alerts',
          emails: {
            title: 'Email Addresses',
            subtitle: 'Enter email addresses to receive notifications about new alerts.',
            placeholder: 'Enter email addresses separated by commas'
          }
        },
        categories: {
          title: 'Ongoing Screening Categories',
          no_category_selected_hint: 'All categories will be screened if no category is selected.',
          pep: {
            title: 'Politically Exposed Person'
          },
          soe: {
            title: 'State-owned Enterprise'
          },
          sanction: {
            title: 'Sanctions'
          },
          other: {
            title: 'Others'
          }
        }
      }
    }
  },
  user_profile: {
    title: 'User Profile',
    form_basic_info: {
      title: 'Basic Information',
      subtitle: 'View your basic information',
      username: {
        label: 'Username'
      },
      organization_name: {
        label: 'Organization Name'
      },
      role: {
        label: 'Role'
      },
      access_menus: {
        label: 'Access Menus'
      }
    },
    form_reset_pwd: {
      title: 'Reset Password',
      subtitle: 'Change your password',
      msg: {
        success: {
          title: 'Success',
          text: 'Password changed successfully'
        },
        error: {
          title: 'Error',
          text: 'Failed to change password'
        }
      },
      actions: {
        reset: 'Reset'
      },
      old_password: {
        label: 'Old Password'
      },
      new_password: {
        label: 'New Password'
      },
      confirm_password: {
        label: 'Confirm Password'
      }
    }
  },
  menus: {
    dashboard: {
      title: 'Dashboard'
    },
    company: {
      title: 'Company',
      menus: {
        list: {
          title: 'List Company'
        },
        new: {
          title: 'Add Company'
        }
      }
    },
    person: {
      title: 'Natural Person',
      menus: {
        list: {
          title: 'List Natural Person'
        },
        new: {
          title: 'Add Natural Person'
        }
      }
    },
    transaction: {
      title: 'Transaction',
      menus: {
        statistics: {
          title: 'Transaction Statistics'
        }
      }
    },
    alert: {
      title: 'Alerts'
    },
    alertCasePool: {
      title: 'Alert Case Pool'
    },
    screen: {
      title: 'Name Screening',
      menus: {
        single: {
          title: 'Single Screening'
        },
        onboarding: {
          title: 'Onboarding Screening'
        },
        batch: {
          title: 'Batch Screening'
        },
        log: {
          title: 'Batch Screening Log'
        },
        ongoing: {
          title: 'Ongoing Screening'
        }
      }
    },
    import: {
      title: 'Data Import'
    },
    export: {
      title: 'Data Export'
    },
    auditlog: {
      title: 'Audit Log'
    },
    develop: {
      title: 'Development',
      menus: {
        webhook: {
          title: 'Webhook'
        },
        webhookLog: {
          title: 'Webhook Log'
        }
      }
    },
    ekyc: {
      title: 'eKYC Alliance'
    },
    settings: {
      title: 'Settings'
    },
    logout: {
      title: 'Logout'
    },
    reset_pwd: {
      title: 'Reset Password'
    }
  },
  footer: {
    copyright: `© Copyright ${new Date().getFullYear()} TESS ASIA. All Rights Reserved.`
  }
}
